import { UploadType } from "@/api/types";
import useControlledState from "@/hooks/useControlledState";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { ButtonType } from "antd/es/button";
import { ReactNode } from "react";

import { TableProps } from "../Table/Table";
import { FileUploaderModal } from "./FileUploaderModal";
import { UploadParameters } from "./ValidationStep";

export interface FileUploaderProps {
  uploadType: UploadType;
  buttonText?: string;
  productIds?: string[];
  buttonType?: ButtonType;
  uploadDataTableProps: TableProps;
  uploadParameters?: UploadParameters;
  howItWorks?: ReactNode;
  templateUrlFn?: () => Promise<string>;
  icon?: ReactNode;
  disabled?: boolean;
  tooltipText?: string;
  parentPopupIsOpen?: boolean;
  parentTabOnChange?: (open: boolean) => void;
  children?: ReactNode;
  customRender?: (props: { onClick: () => void }) => ReactNode;
  note?: ReactNode;
}

const FileUploader = ({
  uploadType,
  buttonText,
  productIds,
  buttonType,
  uploadDataTableProps,
  howItWorks,
  templateUrlFn,
  icon,
  disabled,
  tooltipText,
  parentPopupIsOpen,
  parentTabOnChange,
  children,
  customRender,
  note,
}: FileUploaderProps) => {
  const [popupIsOpen, setPopupIsOpen] = useControlledState(
    false,
    parentPopupIsOpen,
    parentTabOnChange
  );

  const displayIcon = icon ? "" : <UploadOutlined />;
  const buttonStyles = buttonType === "link" ? { padding: 0 } : {};

  return (
    <>
      {children || (
        <Tooltip
          trigger="hover"
          title={tooltipText}
        >
          {customRender ? (
            customRender({ onClick: () => setPopupIsOpen(true) })
          ) : (
            <Button
              onClick={() => setPopupIsOpen(true)}
              icon={displayIcon}
              disabled={disabled}
              type={buttonType || "default"}
              style={buttonStyles}
            >
              {buttonText || "Upload"}
            </Button>
          )}
        </Tooltip>
      )}
      {popupIsOpen && (
        <FileUploaderModal
          note={note}
          isOpen={popupIsOpen}
          setIsOpen={setPopupIsOpen}
          uploadType={uploadType}
          productIds={productIds}
          templateUrlFn={templateUrlFn}
          uploadDataTableProps={uploadDataTableProps}
          howItWorks={howItWorks}
        />
      )}
    </>
  );
};

export default FileUploader;
